import { motion } from "framer-motion";
import { Camera, PenTool } from "lucide-react";

const reveal = { initial: { opacity: 0, y: 30 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, amount: 0.2 }, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } };

export const GalleryIntro = () => (
  <motion.div {...reveal} initial={{ opacity: 0, y: 40 }} transition={{ ...reveal.transition, duration: 0.75 }}>
    <p className="font-mono-ui text-[11px] uppercase tracking-[0.3em] text-pink-400 mb-4">Galerie — du vrai travail, à la main</p>
    <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-none">Réalisations</h2>
    <p className="mt-4 max-w-2xl text-slate-300 text-base sm:text-lg leading-relaxed">Des vraies fresques, des vrais customs et de la vraie mécanique, peints et réparés à la main. Pas des rendus — du concret.</p>
  </motion.div>
);

export const GalleryWork = ({ work, index }) => (
  <motion.figure {...reveal} transition={{ ...reveal.transition, delay: 0.05 * index }} className="relative group overflow-hidden rounded-2xl border border-line bg-panel" data-testid={`gallery-item-${work.id}`}>
    <img src={work.src} alt={work.caption} loading="lazy" className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500" data-testid={`gallery-image-${work.id}`} />
    <figcaption className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-ink/95 to-transparent">
      <span className="font-mono-ui text-[10px] uppercase tracking-widest text-pink-300">{work.tag}</span>
      <p className="text-sm text-slate-100 mt-0.5">{work.caption}</p>
    </figcaption>
  </motion.figure>
);

export const GalleryInvitation = ({ onQuote }) => (
  <motion.div {...reveal} transition={{ ...reveal.transition, delay: 0.35 }} className="relative flex flex-col items-center justify-center gap-4 rounded-2xl border-2 border-dashed border-pink-500/40 bg-panel/40 p-8 text-center min-h-[220px]" data-testid="gallery-cta-tile">
    <Camera size={26} className="text-pink-400" />
    <p className="font-display uppercase text-2xl text-slate-100">Ton projet ici ?</p>
    <button onClick={() => onQuote(null)} data-testid="gallery-cta-button" className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-pink-500 text-ink font-bold text-xs uppercase tracking-wide" style={{ boxShadow: "0 0 22px rgba(236,72,153,0.4)" }}>
      <PenTool size={14} />Demander un devis
    </button>
  </motion.div>
);